module.exports = __webpack_public_path__ + "static/media/blackjack.a600db04.jpeg";